import React from "react";
import "./CSS/StatusSection.css";

const StatsSection = () => {
  return (
    <div className="stats-container">
     <div className="stats-box">
  <svg className="wave" viewBox="0 0 600 200">
    <path d="M0 100 Q150 50 300 100 T600 100" />
    <path d="M0 130 Q150 80 300 130 T600 130" />
    <path d="M0 160 Q150 110 300 160 T600 160" />
  </svg>

        <div className="stat">
          <h2>2+</h2>
          <p>Years of experience</p>
        </div>

        <div className="stat">
          <h2>7+</h2>
          <p>Team Members</p>
        </div>

        <div className="stat">
          <h2>43+</h2>
          <p>Happy Clients</p>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;